import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown } from "../../../common/component/Index";
import Agent from './../../../../../models/Agent';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
import AgentListReports from './AgentListReports';

const ListCols = ['name', 'email', 'phoneNumber', 'taxNumber', 'address', 'contactFullname', 'contactEmail', 'contactPhoneNumber', 'createdDate'];
const ModelFields = Object.getOwnPropertyNames(new Agent());

class AgentList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                email: {
                    key: 'email',
                    sorter: (i, k) => i.email.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                        overlayClassName={'max-width-500'} />
                },
                name: {
                    key: 'name',
                    sorter: (i, k) => i.name.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                phoneNumber: {
                    key: 'phoneNumber',
                    sorter: (i, k) => i.phoneNumber.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                taxNumber: {
                    key: 'taxNumber',
                    sorter: (i, k) => i.taxNumber.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                createdDate: {
                    width: 150,
                    key: 'createdDate',
                    sorter: (i, k) => i.createdDate.length - k.length,
                    render: (date, record) => moment(moment.utc(date).toDate().toJSON()).format('DD-MM-YYYY HH:mm'),
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
            expandedRows: []
        };
    }

    render() {
        const { loading, pagination, agents } = this.props;
        const { titleItemTable, modelItem, componentTable, expandedRows } = this.state;
        return (
            <ListComponent
            
                scroll={{ x: 1300 }}
                tableKey="agents-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(agents || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'agent'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                expandedRowRender={this.renderAgentListReports}
                onExpand={this.onRowExpanded}
                onColumnVisibleChange={this.onColumnVisibleChange}
                expandedRowKeys={expandedRows}
                onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
            />
        );
    }

    renderAgentListReports = (record, index, indent, expanded) => {
        const { loadingGroup } = this.props;

        return (
            <AgentListReports
                data={record.detail}
                loading={loadingGroup}
                onTableChange={(pagination, filters, sorter) => this.props.onDetailTableChange(record, pagination, filters, sorter)}
            />
        )
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.id) {
            this.props.onItemExpanded(expanded, record)
        }
    }
    
    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeAgent = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.category.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeAgent,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.AGENT.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable(['name', 'key', 'value', 'createdDate', 'translations'], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(AgentList);

AgentList.defaultProps = {
    data: {},
    filters: {},
    loading: false,
    onTableChange: () => { },
    onItemExpanded: (expanded, record) => { },
    onDetailTableChange: (record, pagination, filters, sorter) => { },
}